import React from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import useAuth from "customHook/useAuth";
import { SuccessIcon } from 'assets/icons';
import { Container } from './styles';

const ModalResetPasswordSent = ({
  isOpen,
  setIsOpen,
  type
}) => {

  const { validToken } = useAuth();

  return (
    <MainModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className="modal-success"
      additionalstyle={`
        max-width: 500px;
        .modal-content{
          height: 100%;
          .close {
            z-index: 200;
          }   
          .modal-body{
            height: 100%;
            padding: 24px;
          }
        }
        top: 179px;
      `}
    >
      <Container>
        <SuccessIcon />
        <div className='text'>{validToken? `Please check your email address associated with this account. You'll receive a password reset link shortly.` : type==='EMAIL'? `If an account is associated with this email address, you'll receive a password reset link shortly. Please check your inbox and spam folder.`: `If an account is associated with this phone number, you'll receive a password reset link shortly.`}</div>
        <Button
          success
          onClick={() => setIsOpen(false)}
          additionalstyle={`
            width: 116px;
            margin-top: 24px;
          `} 
        >
          OK
        </Button>
      </Container>
    </MainModal>
  );
}

export default ModalResetPasswordSent;
